module.exports = __webpack_public_path__ + "static/media/skype.b15a47bd.svg";